export default __webpack_public_path__ + "media/bundles/App/layout/icon/svgs/plus-circle-a695a0f369c95f90cac670b6a08241d4.svg";